import {ExportSeniorsReportData} from './export-seniors-get-report-data';

export function exportSeniorsProcessReportData({
  reportData,
}: {
  reportData: ExportSeniorsReportData['reportData'];
}): ExportSeniorsReportData['reportData'] {
  return [...reportData].sort(sortByName);
}

function sortByName(entryA: any, entryB: any) {
  return getUserName(entryA.userId).localeCompare(getUserName(entryB.userId), undefined, {
    sensitivity: 'base',
  });
}

function getUserName(user?: any) {
  return user?.displayName ?? user?.name ?? '';
}
